import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { NavService } from '../../../services/nav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { BaseServicesService } from 'src/app/services/base-services/base-services.service';
import { NavItem } from './nav-item/nav-item';
import { LoggingService } from 'src/app/services/consoleLogs';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
interface MiniNavIcon {
  icon: string;
  route: string;
  label: string;
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})


export class SidebarComponent implements OnInit, OnChanges,OnDestroy{
  navItems: NavItem[] = [];
  isLoading: boolean = true;
  private hasLoggedIcons = false;
  collapsedIcons: MiniNavIcon[] = [];
  @Output() itemSelected = new EventEmitter<NavItem>();
  @Input() sidenav: any;
  @Input() isCollapsed: boolean = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  
  // Reusable input: lets parent provide nav items instead of fetching them.
  @Input() navItemsInput: NavItem[] | null = null;
private subscriptions: Subscription[] = [];

  // Bottom user card
  userName: string = '';
  userRole: string = '';
  userAvatarUrl: string = '../../../../assets/images/logos/NoProfile.jpg';
  defaultAvatarUrl: string = '../../../../assets/images/logos/NoProfile.jpg';
  constructor(
    public navService: NavService,
    private baseService: BaseServicesService,
    private loggingService: LoggingService,
    private router: Router
  ) { }

  

  ngOnInit(): void {
    if (this.navItemsInput?.length) {
      this.navItems = this.navItemsInput;
      this.isLoading = false;
    } else {
      this.sidenNavFeatureApi();
    }
    this.loadUserCard();
    this.subscribeToUserChanges();

  }
  get collapsedNavItems(): NavItem[] {
  return this.navItems.filter(item => !item.navCap);
}
ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['navItemsInput']) {
      const nextVal = changes['navItemsInput'].currentValue as NavItem[] | null;
      if (nextVal?.length) {
        this.navItems = nextVal;
        this.isLoading = false;
      }
    }

    if (changes['isCollapsed']) {
      console.log('🔵 [SidebarComponent] isCollapsed changed from', 
        changes['isCollapsed'].previousValue, 'to', changes['isCollapsed'].currentValue);
      
      // Only log when collapsing, not on initial load
      if (changes['isCollapsed'].currentValue === true && 
          changes['isCollapsed'].previousValue === false) {
        console.log('📌 Sidebar collapsed - logging icons NOW');
        this.logAllChildrenIcons();
      }
      
      // Reset flag when expanding
      if (changes['isCollapsed'].currentValue === false) {
        console.log('📌 Sidebar expanded - resetting log flag');
        this.hasLoggedIcons = false;
      }
    }
  }



  toggleSidenav(): void {
    this.sidenav.toggle();
  }

   private loadUserCard(): void {
    this.baseService.getUserDetailsById().subscribe({
      next: (res) => {
        const data = res?.data ?? res;
        this.userName = data?.name ?? data?.fullName ?? 'User';
        this.userRole = data?.role?.name ?? data?.roleName ?? data?.permissionType ?? 'Role';
        this.userAvatarUrl = data?.profilePic ?? data?.avatar ?? data?.imageUrl ?? this.defaultAvatarUrl;
        
        // Update the shared service with initial values
        this.baseService.updateUserData({
          name: this.userName,
          avatar: this.userAvatarUrl,
          role: this.userRole
        });
      },
      error: () => {
        this.userName = 'User';
        this.userRole = 'Role';
        this.userAvatarUrl = this.defaultAvatarUrl;
      }
    });
  }

  private subscribeToUserChanges(): void {
    // Subscribe to name changes
    this.subscriptions.push(
      this.baseService.userName$.subscribe(name => {
        if (name) {
          this.userName = name;
        }
      })
    );

    // Subscribe to avatar changes
    this.subscriptions.push(
      this.baseService.userAvatar$.subscribe(avatar => {
        if (avatar) {
          this.userAvatarUrl = avatar;
        }
      })
    );

    // Subscribe to role changes
    this.subscriptions.push(
      this.baseService.userRole$.subscribe(role => {
        if (role) {
          this.userRole = role;
        }
      })
    );
  }
  findParentNavCapByChildName(childName: string): string | null {
    for (const parent of this.navItems) {
      if (
        parent.children &&
        parent.children.some((c) => c.displayName === childName)
      ) {
        return parent.navCap ?? null;
      }
    }
    return null;
  }

  logAllChildrenIcons(): void {
    // Only proceed if we haven't logged icons in this collapsed session
    if (this.hasLoggedIcons) {
      console.log('📋 [SidebarComponent] Icons already logged in this collapsed session - skipping');
      return;
    }
    
    console.log('📋 [SidebarComponent] ===== COLLAPSED STATE ACTIVATED =====');
    console.log('📋 [SidebarComponent] Logging all children icon names:');
    
    const allIconNames: string[] = [];
    
    this.navItems.forEach(parent => {
      if (parent.children && parent.children.length > 0) {
        console.log(`📁 Parent: ${parent.navCap}`);
        
        parent.children.forEach(child => {
          if (child.iconName) {
            console.log(`  🖼️ Child: ${child.displayName} - Icon: ${child.iconName}`);
            allIconNames.push(child.iconName);
          }
        });
      }
    });
    
    console.log('📋 [SidebarComponent] All Children Icons Array:', JSON.stringify(allIconNames));
    console.log('📋 [SidebarComponent] Total icons count:', allIconNames.length);
    console.log('📋 [SidebarComponent] ===== END =====');
    
    // Also log as a clean array for easy copying
    console.log('📋 [SidebarComponent] Clean array for copying:', allIconNames);
    
    this.hasLoggedIcons = true;
  }

  onParentIconClick(parent: NavItem): void {
    console.log('🟢 [SidebarComponent] Parent icon clicked:', parent.navCap);
    
    if (parent.children) {
      const childIcons = parent.children.map(c => c.iconName).filter(icon => icon);
      console.log(`🟢 [SidebarComponent] Children icons for ${parent.navCap}:`, childIcons);
    }
    
    if (parent.children && parent.children.length > 0) {
      const firstChild = parent.children[0];
      if (firstChild.route) {
        console.log('🟢 [SidebarComponent] Navigating to:', firstChild.route);
        this.router.navigate([firstChild.route]);
      }
    }
  }

  hasActiveChild(parent: NavItem): boolean {
    if (!parent.children) return false;
    
    const currentUrl = this.router.url;
    const hasActive = parent.children.some(child => 
      child.route && currentUrl.includes(child.route)
    );
    
    if (hasActive) {
      console.log('🟡 [SidebarComponent] Active parent detected:', parent.navCap);
      
      const activeChild = parent.children.find(child => 
        child.route && currentUrl.includes(child.route)
      );
      if (activeChild) {
        console.log(`🟡 [SidebarComponent] Active child icon: ${activeChild.iconName}`);
      }
    }
    
    return hasActive;
  }

  sidenNavFeatureApi(): void {
    this.isLoading = true;

    this.baseService.getFeatureOptions().subscribe({
      next: (res) => {
        this.isLoading = false;
        this.loggingService.log('API Response:', res);

        if (res.data && res.data.features) {
          this.navItems = this.transformApiResponse(res.data.features);
          this.loggingService.log('Transformed Nav Items:', this.navItems);

          const parent = this.findParentNavCapByChildName('Analytics');
          this.loggingService.log('Parent navCap of Analytics:', parent);
          
          // NO ICON LOGGING HERE - Only logs when collapsed
        } else {
          this.loggingService.warn('Invalid API response structure');
          this.navItems = [];
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.loggingService.error('API Error:', err);
        this.navItems = [];
      },
    });
  }

  private transformApiResponse(features: any[]): NavItem[] {
    return features
      .filter((feature) => {
        const hasNavCap = !!feature.navCap;
        const hasChildren = feature.children && feature.children.length > 0;
        return hasNavCap && hasChildren;
      })
      .map((feature) => ({
        id: feature.id,
        navCap: feature.navCap,
        parentIcon: feature.parentIcon,   
        expanded: feature.expanded || false,
        children: (feature.children || [])
          .map((child: any) => ({
            displayName: child.displayName,
            iconName: child.iconName,
            route: child.route,
            relatedRoutes: child.relatedRoutes || [],
            disabled: child.disabled || false,
            external: child.external || false,
            permissionType: child.permissionType,
            tabs: child.tabs
              ? child.tabs.map((tab: any) => ({
                  tabName: tab.tabName,
                  route: tab.route,
                  iconName: tab.iconName,
                  permissionType: tab.permissionType,
                }))
              : []
          }))
          .filter((child: any) => child.displayName && child.route),
      }))
      .filter((navItem) => navItem.children.length > 0);
  }

  logout(): void {
    this.router.navigate(['/']);
    localStorage.removeItem('authToken');
  }
  onNavItemClicked(item: NavItem) {
    this.itemSelected.emit(item);
  }
}